/* tslint:disable */
/* eslint-disable */
/* Mocked in-memory implementation of DashboardClient for local development and UI wiring. */

import { CancelToken } from 'axios';
import {
  DashboardInvoiceSummaryResponse,
  DashboardCreditSummaryResponse,
  DashboardDeliveriesSummaryResponse,
} from '../../types';

/* ---- Helper Functions ---- */

function delay(ms: number = 300): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

/* ---- Mocked Client Implementation ---- */

import { IDashboardClient } from '../../interfaces';
export class DashboardClientMocked implements IDashboardClient {
  constructor(baseUrl?: string) {}

  async invoiceSummary(fromDate: string, toDate: string, cancelToken?: CancelToken): Promise<DashboardInvoiceSummaryResponse> {
    await delay();
    return {
      totalInvoices: 156,
      totalValue: 45678.90,
      pendingInvoices: 12,
      processedInvoices: 144,
      invoicesByStatus: [
        { status: 'Pending', count: 12 },
        { status: 'Processed', count: 100 },
        { status: 'Disputed', count: 5 },
        { status: 'Credited', count: 39 },
      ],
    } as DashboardInvoiceSummaryResponse;
  }

  async creditSummary(fromDate: string, toDate: string, cancelToken?: CancelToken): Promise<DashboardCreditSummaryResponse> {
    await delay();
    return {
      totalCredits: 23,
      totalValue: 1234.56,
      pendingCredits: 5,
      approvedCredits: 15,
      rejectedCredits: 3,
    } as DashboardCreditSummaryResponse;
  }

  async deliveriesSummary(fromDate: string, toDate: string, cancelToken?: CancelToken): Promise<DashboardDeliveriesSummaryResponse> {
    await delay();
    return {
      deliveries: [
        {
          purchaseOrderId: 1001,
          status: 'Delivered',
          deliveryDate: '2025-01-02T10:00:00Z',
          receivedDate: '2025-01-02T10:15:00Z',
          shortages: 0,
          retailer: 'Dublin Delights Café',
          franchise: 'CFA',
        },
        {
          purchaseOrderId: 1002,
          status: 'Delivered',
          deliveryDate: '2025-01-03T14:30:00Z',
          receivedDate: '2025-01-03T14:30:00Z',
          shortages: 2,
          retailer: 'Cork Coffee Corner',
          franchise: 'CFA',
        },
        {
          purchaseOrderId: 1003,
          status: 'InTransit',
          deliveryDate: '2025-01-05T09:00:00Z',
          receivedDate: null,
          shortages: 0,
          retailer: 'Galway Gourmet',
          franchise: 'CFA',
        },
        {
          purchaseOrderId: 1004,
          status: 'Delivered',
          deliveryDate: '2025-01-01T08:00:00Z',
          receivedDate: '2025-01-01T08:20:00Z',
          shortages: 1,
          retailer: 'Belfast Beverages',
          franchise: 'Orderly',
        },
        {
          purchaseOrderId: 1005,
          status: 'Delayed',
          deliveryDate: '2025-01-04T11:00:00Z',
          receivedDate: null,
          shortages: 0,
          retailer: 'Dublin Delights Café',
          franchise: 'CFA',
        },
        {
          purchaseOrderId: 1006,
          status: 'DeliveredOnTime',
          deliveryDate: '2024-12-28T15:00:00Z',
          receivedDate: '2024-12-28T15:00:00Z',
          shortages: 0,
          retailer: 'Galway Gourmet',
          franchise: 'CFA',
        },
        {
          purchaseOrderId: 1007,
          status: 'Delivered',
          deliveryDate: '2024-12-30T10:30:00Z',
          receivedDate: '2024-12-30T11:00:00Z',
          shortages: 3,
          retailer: 'Cork Coffee Corner',
          franchise: 'CFA',
        },
      ],
    } as DashboardDeliveriesSummaryResponse;
  }
}
